import morphism, { StrictSchema } from 'morphism'

import ClientFlightWithTravelClassSeatCountsInterface from '../../interfaces/server/FlightWithTravelClassSeatCounts'
import ServerTravelClassSeatCountInterface from '../../interfaces/server/TravelClassSeatCount'
import ClientTravelClassSeatCountInterface from '../../interfaces/client/TravelClassSeatCount'

import constants from '../../config/constants'

import store from '../../store'

import travelClassSeatCountSchema from './travelClassSeatCount'

import {
  dateToFrontEndFormat,
  dateToHoursFormat,
  dateToDayFormat,
} from '../../utils/dates'

const getAirportById = (id: string) => {
  const state = store.getState()

  return (
    state.v1airports.items.find((airport: any) => airport.id === id) || {
      name: id,
    }
  )
}

export const departureDate = ({
  std,
}: ClientFlightWithTravelClassSeatCountsInterface) =>
  dateToFrontEndFormat(std, constants.stdDateFormat)

export const departureTime = ({
  std,
}: ClientFlightWithTravelClassSeatCountsInterface) =>
  dateToHoursFormat(std, constants.stdDateFormat)

export const departureDay = ({
  std,
}: ClientFlightWithTravelClassSeatCountsInterface) =>
  dateToDayFormat(std, constants.stdDateFormat)

export const arrivalDate = ({
  sta,
}: ClientFlightWithTravelClassSeatCountsInterface) =>
  dateToFrontEndFormat(sta, constants.stdDateFormat)

export const arrivalTime = ({
  sta,
}: ClientFlightWithTravelClassSeatCountsInterface) =>
  dateToHoursFormat(sta, constants.stdDateFormat)

export const arrivalDay = ({
  sta,
}: ClientFlightWithTravelClassSeatCountsInterface) =>
  dateToDayFormat(sta, constants.stdDateFormat)

export const route = ({
  origin,
  destination,
}: ClientFlightWithTravelClassSeatCountsInterface) => `${origin}-${destination}`

export const origin = ({
  origin,
}: ClientFlightWithTravelClassSeatCountsInterface) =>
  getAirportById(origin).name

export const destination = ({
  destination,
}: ClientFlightWithTravelClassSeatCountsInterface) =>
  getAirportById(destination).name

export const travelClassSeatCounts = ({
  travelClassSeatCounts = [],
}: ClientFlightWithTravelClassSeatCountsInterface) =>
  travelClassSeatCounts.map(
    (travelClassSeatCount: ServerTravelClassSeatCountInterface) =>
      morphism<
        StrictSchema<
          ClientTravelClassSeatCountInterface,
          ServerTravelClassSeatCountInterface
        >
      >(travelClassSeatCountSchema, travelClassSeatCount)
  )

export default {
  flightId: 'flight.id',
  flightNumber: 'flightNumber',
  route,

  origin,
  originCode: 'origin',
  destination,
  destinationCode: 'destination',

  arrivalDate,
  arrivalDay,
  arrivalTime,

  departureDate,
  departureDay,
  departureTime,

  travelClassSeatCounts,
}
